import { IntlShape } from 'react-intl';
import { ModuleHierachy } from 'src/app/common/module/types';
import { isPermitted } from 'src/app/common/utils';
import {
  COMMISSION_TOOL_TITLE,
  MASTER_DATA_SETTING_TITLE,
  CONTRACT_SETTING_TITLE,
  COMMISSION_TOOL_BASE_PATH,
  MASTER_DATA_SETTING_PATH,
  CONTRACT_SETTING_PATH,
  MASTER_DATA_SETTING_NAMESPACE,
  CONTRACT_SETTING_NAMESPACE,
  AdminCommissionToolPermissionType,
} from './constants';
import MasterDataSettingRoutes from './pages/master-data-setting/master-data-setting-routes';
import ContractSettingRoutes from './pages/contract-setting/contract-setting-routes';

export const commissionToolModuleConfig = (permissions: string[], intl: IntlShape): ModuleHierachy => {
  const Translation = (id: string) => intl.formatMessage({ id });
  return {
    title: Translation(COMMISSION_TOOL_TITLE),
    path: COMMISSION_TOOL_BASE_PATH,
    icon: '/media/svg/icons/Media/Equalizer.svg',
    enableRead: isPermitted(
      [
        AdminCommissionToolPermissionType.MASTER_DATA_SETTING_READ,
        AdminCommissionToolPermissionType.CONTRACT_SETTING_READ,
      ],
      permissions,
    ),
    child: [
      {
        title: Translation(MASTER_DATA_SETTING_TITLE),
        path: `${COMMISSION_TOOL_BASE_PATH}${MASTER_DATA_SETTING_PATH}`,
        namespace: MASTER_DATA_SETTING_NAMESPACE,
        component: MasterDataSettingRoutes,
        enableRead: isPermitted([AdminCommissionToolPermissionType.MASTER_DATA_SETTING_READ], permissions),
        enableUpdate: isPermitted([AdminCommissionToolPermissionType.MASTER_DATA_SETTING_UPDATE], permissions),
      },
      {
        title: Translation(CONTRACT_SETTING_TITLE),
        path: `${COMMISSION_TOOL_BASE_PATH}${CONTRACT_SETTING_PATH}`,
        namespace: CONTRACT_SETTING_NAMESPACE,
        component: ContractSettingRoutes,
        enableRead: isPermitted([AdminCommissionToolPermissionType.CONTRACT_SETTING_READ], permissions),
        enableCreate: isPermitted([AdminCommissionToolPermissionType.CONTRACT_SETTING_CREATE], permissions),
        enableUpdate: isPermitted([AdminCommissionToolPermissionType.CONTRACT_SETTING_UPDATE], permissions),
        enableDelete: isPermitted([AdminCommissionToolPermissionType.CONTRACT_SETTING_DELETE], permissions),
        options: {
          enableDelete: true,
        },
      },
    ],
  };
};
